import { NavigationMenuClickedProps } from "@ifgengineering/client-analytics/src/types";
import { logException } from "@helpers/logException/logException";
import useAnalytics from "@helpers/useAnalytics";

export const useNavigationMenuClicked = () => {
  const navigationMenuClicked = useAnalytics("navigationMenuClicked");
  const triggerNavigationMenuClicked = async (
    args: NavigationMenuClickedProps
  ) => {
    try {
      (await navigationMenuClicked)({
        ...args,
      });
    } catch (error) {
      logException({
        message: `Error when registering navigation-click analytics - ${JSON.stringify(
          args
        )}`,
        exception: error,
      });
    }
  };

  return {
    triggerNavigationMenuClicked,
  };
};
